import React from "react";
import type { PermissionType } from "../types";
import { checkPermission } from "../utils";

// 权限图标组件
interface PermissionIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  permission: number | string;
  type?: PermissionType;
  icon: React.ReactNode;
  // 多权限支持
  permissions?: Array<{ permission: number | string; type?: PermissionType }>;
  mode?: "any" | "all";
  // 无权限时的行为
  fallback?: "hide" | "disable"; // 隐藏 or 禁用
}

export const PermissionIcon: React.FC<PermissionIconProps> = ({
  permission,
  type = "system",
  permissions,
  mode = "any",
  fallback = "hide",
  icon,
  onClick,
  ...spanProps
}) => {
  // 单一权限检查
  const hasSinglePermission = () => {
    return checkPermission(permission, type);
  };

  // 多权限检查
  const hasMultiplePermissions = () => {
    if (!permissions || permissions.length === 0) return false;

    const results = permissions.map(
      ({ permission: perm, type: permType = "system" }) =>
        checkPermission(perm, permType)
    );

    return mode === "any" ? results.some(Boolean) : results.every(Boolean);
  };

  // 决定使用哪种权限检查方式
  const hasPermission =
    permissions && permissions.length > 0
      ? hasMultiplePermissions()
      : hasSinglePermission();

  // 无权限时的处理
  if (!hasPermission) {
    if (fallback === "hide") {
      return null;
    }
    if (fallback === "disable") {
      return (
        <span
          {...spanProps}
          style={{
            ...spanProps.style,
            opacity: 0.3,
            cursor: "not-allowed",
            pointerEvents: "none",
          }}
        >
          {icon}
        </span>
      );
    }
  }

  // 有权限时正常渲染
  return (
    <span {...spanProps} onClick={onClick}>
      {icon}
    </span>
  );
};
